module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vbl-form-item",
    class: {
      'is-inline': _vm.inline, 'is-error': _vm.formErrors.has(_vm.computedName)
    }
  }, [_vm._t("default"), _c('p', {
    staticClass: "error-msg"
  }, [_vm._v(_vm._s(_vm.formErrors.first(_vm.computedName)))])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b14443c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblForm/src/vblFormItem.vue
// module id = 269
// module chunks = 0